import { mergeDeep } from '@givebacks/utils/objects';

import { QueryPagination, SearchSettings } from './types';
import { createQueryPagination } from './utils/createQueryPagination';
import { createSearchQuery } from './utils/createSearchQuery';

const createDefaultSearchKey = <T extends SearchSettings>(searchObject: T): T => {
  const defaultOffersSearchObject = {
    searches: {},
    order: {},
    join: {},
    options: {},
  };
  return mergeDeep(defaultOffersSearchObject, searchObject) as T;
};

/**
 *
 * @param
 * @returns
 */
const createQueryOptions = <T extends SearchSettings>({
  search,
  pagination,
  existingSearchString,
  withPagination = true,
}: {
  /** Search Settings Object for the query */
  search?: T;
  pagination?: QueryPagination;
  existingSearchString?: string;
  withPagination?: boolean;
}) => {
  const { queryString: querySearchString } = createSearchQuery<T>(search);
  const queryObject = createDefaultSearchKey(search ?? {});
  const { page, paginationQuery, limit } = createQueryPagination(pagination);
  // If the first char is ? or &
  const existingWithoutPage = existingSearchString?.replace(/^[?&]/, '') ?? '';
  const cleanedQuerySearch = querySearchString ? '&' + querySearchString.replace(/^[?&]/i, '') : '';
  let queryString = existingWithoutPage + `${cleanedQuerySearch}`;
  if (withPagination) {
    queryString += `&${paginationQuery}`;
  }
  return {
    queryString,
    queryObject,
    page,
    paginationQuery,
    querySearchString,
    queryPagination: {
      page,
      limit,
    },
  };
};

export { createQueryOptions };
